import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { withApollo } from './apolloClient';
import cacheOptions from './cacheOptions';
import withRemoveInitialReduxState from './withRemoveInitialReduxState';
export default function apolloExtension() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$clearCacheOn = options.clearCacheOnLogin,
      clearCacheOnLogin = _options$clearCacheOn === void 0 ? false : _options$clearCacheOn,
      _options$globalEnable = options.globalEnableGetDataFromTree,
      globalEnableGetDataFromTree = _options$globalEnable === void 0 ? true : _options$globalEnable,
      restOfOptions = _objectWithoutProperties(options, ["clearCacheOnLogin", "globalEnableGetDataFromTree"]); // Keep reference to current apollo client for middleware


  var apolloClient;

  var onApolloClientCreated = currentApolloClient => {
    apolloClient = currentApolloClient;
  };

  var apolloOptions = _objectSpread({
    cacheOptions,
    errorCodeRules: [],
    onApolloClientCreated
  }, restOfOptions);

  return {
    id: 'apollo',
    server: process.browser ? undefined : {
      init() {
        require('./config');
      },

      configure(server) {
        var _require = require('./supergraphProxyMiddleware'),
            supergraphProxyMiddleware = _require.default;

        server.useTracked('supergraphProxyMiddleware', supergraphProxyMiddleware());

        var _require2 = require('./graphqlProxyMiddleware'),
            graphqlProxyMiddleware = _require2.default;

        server.useTracked('graphqlProxyMiddleware', graphqlProxyMiddleware());
      }

    },

    redux() {
      var reduxConfig = {};

      if (process.browser && clearCacheOnLogin) {
        /**
         * Setup middleware to watch for successful login / sign up
         * and clear the apollo cache when this happens so queries
         * get recalled since data could be different for user
         */
        var apolloClearStoreOnLoginAndSignupMiddleware = store => next => action => {
          var type = action === null || action === void 0 ? void 0 : action.type;

          if ( // FIXME: Import these from `@techstyle/react-accounts` but
          // avoid circular references
          type === 'accounts/signUpSuccess' || type === 'accounts/logInSuccess') {
            if (apolloClient) {
              apolloClient.clearStore();
            }
          }

          return next(action);
        };

        var extension = {
          middleware: [apolloClearStoreOnLoginAndSignupMiddleware]
        };
        reduxConfig.extensions = [extension];
      }

      return reduxConfig;
    },

    page(_ref) {
      var enableGetDataFromTree = _ref.enableGetDataFromTree;
      return {
        getInitialProps(ctx) {
          return _asyncToGenerator(function* () {
            ctx.enableGetDataFromTree = enableGetDataFromTree !== null && enableGetDataFromTree !== void 0 ? enableGetDataFromTree : globalEnableGetDataFromTree;
          })();
        }

      };
    },

    app: {
      enhance(App) {
        if (process.browser) {
          return withApollo(apolloOptions)(App);
        } // When `withApollo` runs `getInitialProps` it should have access to the redux initial state
        // this is so the redux store is populated when running `getDataFromTree`


        var getInitialProps = App.getInitialProps;
        var currentCtx;

        App.getInitialProps = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(function* (_ref2) {
            var Component = _ref2.Component,
                ctx = _ref2.ctx;
            var initialProps = yield getInitialProps({
              Component,
              ctx
            });
            currentCtx = ctx;
            return _objectSpread(_objectSpread({}, initialProps), {}, {
              initialState: ctx.store.getState()
            });
          });

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }();

        var _require3 = require('@apollo/client/react/ssr'),
            getDataFromTree = _require3.getDataFromTree;

        var getDataFromTreeWithPerformance = /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator(function* (app) {
            var performance = currentCtx.req.performance;
            var _currentCtx = currentCtx,
                enableGetDataFromTree = _currentCtx.enableGetDataFromTree;
            var startTime = process.hrtime();
            var entry = {
              type: 'next',
              name: 'getDataFromTree',
              requestStart: performance.getOffset(startTime)
            };
            performance.entries.push(entry);

            try {
              if (enableGetDataFromTree) {
                yield getDataFromTree(app);
              }
            } finally {
              var endTime = process.hrtime();
              entry.duration = performance.getDuration(startTime, endTime);
            }
          });

          return function getDataFromTreeWithPerformance(_x2) {
            return _ref4.apply(this, arguments);
          };
        }();

        return withRemoveInitialReduxState(withApollo(apolloOptions)(App, {
          getDataFromTree: getDataFromTreeWithPerformance
        }));
      }

    }
  };
}